import {
  CONTACT_PAGE_URL,
  HOME_PAGE_URL,
  ABOUT_PAGE_URL,
  LINKS_PAGE_URL,
  CLIPS_FANSITES_PAGE_URL,
  SERVICES_PAGE_URL,
  GALLERY_PAGE_URL,
  TESTIMONIALS_PAGE_URL,
  ADMIN_CONTACT_FORM_PAGE_URL,
} from '../Routes';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About Me' },
  { path: SERVICES_PAGE_URL, label: 'Services' },
  { path: GALLERY_PAGE_URL, label: 'Gallery' },
  { path: CLIPS_FANSITES_PAGE_URL, label: 'Clips/Fansites' },
  { path: LINKS_PAGE_URL, label: 'Links' },
  { path: TESTIMONIALS_PAGE_URL, label: 'Testimonials' },
  { path: CONTACT_PAGE_URL, label: 'Contact' },
  ...(user?.email
    ? user.role === 'ADMIN' || user.role === 'DEVELOPER'
      ? [
          {
            label: 'Admin',
            path: ADMIN_CONTACT_FORM_PAGE_URL,
          },
        ]
      : []
    : []),
];
